module.exports = __webpack_public_path__ + "img/events.c1b4e38f.png";